<app-card-consulta
  (update)="update.emit($event)"
  [titulo]="titulo"
  [idConsulta]="idConsulta"
  [tipoConsulta]="tipoConsulta"
  [codigoControle]="codigoControle"
  [status]="status"
  [token]="token"
>
  <ng-container *ngIf="consulta">
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">Placa </span
        ><span>{{ consulta?.placa || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Marca Modelo </span
        ><span>{{ consulta?.marcaModelo || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Chassi </span
        ><span>{{ consulta?.chassi || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Cor </span
        ><span>{{ consulta?.cor || "NÃO INFORMADO" }}</span>
      </li>

      <li>
        <span class="text-secondary">Município </span
        ><span>{{ consulta?.municipio || "NÃO INFORMADO" }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngFor="let p of consulta?.ocorrenciaHistoricoRFPro; let i = index">
    <h2 class="subtitle">OCORRÊNCIA</h2>
    <ul class="card-list-striped">
      <li>
        <span class="text-secondary">Data Ocorrência </span
          ><span>{{ p?.dataOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Tipo Documento Informante </span
          ><span>{{ p?.tipoDocumentoInformante || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Cor Ocorrência </span
          ><span>{{ p?.corOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Orgão Seguranca </span
          ><span>{{ p?.orgaoSeguranca || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Central Alarme </span
          ><span>{{ p?.centralAlarme || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">DDD Telefone Contato </span
          ><span>{{ p?.dddTelefoneContato || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Telefone Contato </span
          ><span>{{ p?.telefoneContato || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Alarme </span
          ><span>{{ p?.alarme || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">UF Boletim Ocorrência </span
          ><span>{{ p?.ufBoletimOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Ano Modelo Ocorrência </span
          ><span>{{ p?.anoModeloOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Código Ocorrência </span
          ><span>{{ p?.codigoOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Nome Informante </span
          ><span>{{ p?.nomeInformante || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Número Ocorrência </span
          ><span>{{ p?.numeroOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Categoria Ocorrência </span
          ><span>{{ p?.categoriaOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Ano Fabricação Ocorrência </span
          ><span>{{ p?.anoFabriOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Ano </span
          ><span>{{ p?.ano || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Municipio Emplacamento Ocorrência </span
          ><span>{{ p?.muniEmplacaOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">UF Emplacamento Ocorrência </span
          ><span>{{ p?.ufEmplacaOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Código Municipio Ocorrencia </span
          ><span>{{ p?.codigoMunicipioOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Marca Ocorrência </span
          ><span>{{ p?.marcaOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Código Tipo Documento Informante </span
          ><span>{{ p?.codigoTipoDocumentoInformante || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Data Registro Alarme </span
          ><span>{{ p?.dataRegistroAlarme || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Tipo Declaração </span
          ><span>{{ p?.tipoDeclaracao || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Código Tipo Declaração </span
          ><span>{{ p?.codigoTipoDeclaracao || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Ramal Telefone Contato </span
          ><span>{{ p?.ramalTelefoneContato || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Município Ocorrência </span
          ><span>{{ p?.muniOcorrencia || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Hora Registro Alarme </span
          ><span>{{ p?.horaRegistroAlarme || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Boletim </span
          ><span>{{ p?.boletim || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Documento Informante </span
          ><span>{{ p?.documentoInformante || "NÃO INFORMADO" }}</span>
      </li>
      <li>
        <span class="text-secondary">Código Orgão Segurança </span
          ><span>{{ p?.codigoOrgaoSeguranca || "NÃO INFORMADO" }}</span>
      </li>
    </ul>
  </ng-container>
</app-card-consulta>

<ng-container *ngIf="semOcorrencia">
  <app-card-consulta
    [titulo]="statusMsg"
    [status]="status"
    [msg]="texto"
  ></app-card-consulta>
</ng-container>
